import type { SVGProps } from 'react'

interface NebiusIconProps extends SVGProps<SVGSVGElement> {}

export function NebiusIcon(props: NebiusIconProps) {
  return (
    <svg {...props} viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect width='32' height='32' fill='#052B42' rx='8' />
      <path
        fill='#E0FF4F'
        d='M18.468 14a.468.468 0 0 1-.468-.468v-2.877a.655.655 0 0 0-.655-.655h-2.878A.468.468 0 0 1 14 9.532V6.655A.655.655 0 0 0 13.345 6h-2.69a.655.655 0 0 0-.655.655v2.69c0 .362.293.655.655.655h2.877c.258 0 .468.21.468.468v2.877c0 .362.293.655.655.655h2.878c.258 0 .467.21.467.468v3.064a.468.468 0 0 1-.467.468h-2.878a.655.655 0 0 0-.655.655v2.877c0 .258-.21.468-.468.468h-2.877a.655.655 0 0 0-.655.655v2.69c0 .362.293.655.655.655h2.69a.655.655 0 0 0 .655-.655v-2.877c0-.258.209-.467.467-.468h2.878a.655.655 0 0 0 .655-.655v-2.877c0-.258.21-.468.468-.468h2.877a.655.655 0 0 0 .655-.655v-2.69a.655.655 0 0 0-.655-.655h-2.877Z'
      />
    </svg>
  )
}
